// extracted by mini-css-extract-plugin
module.exports = {"products":"Wy-z","misad":"Xy-z","colorSwatchWrapper":"Yy-z","oosMessaging":"Zy-z"};